/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CheckDocumentTypeExists200,
  CreateDocumentTypeDTO,
  DocumentTypeDTO,
  GetAllDocumentTypesParams,
  GetDocumentTypesForFileTypeParams,
  GetDocumentTypesListParams,
  PageDocumentTypeDTO,
  SearchDocumentTypesParams,
  UpdateDocumentTypeDTO,
  ValidateFileForDocumentType200,
  ValidateFileForDocumentTypeParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getDocumentType = (
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DocumentTypeDTO>(
      {url: `/api/document-types/${code}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDocumentTypeQueryKey = (code?: string,) => {
    return [`/api/document-types/${code}`] as const;
    }

    
export const getGetDocumentTypeQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentType>>, TError = unknown>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentTypeQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentType>>> = ({ signal }) => getDocumentType(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentType>>>
export type GetDocumentTypeQueryError = unknown


export function useGetDocumentType<TData = Awaited<ReturnType<typeof getDocumentType>>, TError = unknown>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentType>>,
          TError,
          Awaited<ReturnType<typeof getDocumentType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentType<TData = Awaited<ReturnType<typeof getDocumentType>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentType>>,
          TError,
          Awaited<ReturnType<typeof getDocumentType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentType<TData = Awaited<ReturnType<typeof getDocumentType>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentType<TData = Awaited<ReturnType<typeof getDocumentType>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentTypeQueryOptions(code,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateDocumentType = (
    code: string,
    updateDocumentTypeDTO: UpdateDocumentTypeDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DocumentTypeDTO>(
      {url: `/api/document-types/${code}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDocumentTypeDTO
    },
      options);
    }
  


export const getUpdateDocumentTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentType>>, TError,{code: string;data: UpdateDocumentTypeDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDocumentType>>, TError,{code: string;data: UpdateDocumentTypeDTO}, TContext> => {

const mutationKey = ['updateDocumentType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDocumentType>>, {code: string;data: UpdateDocumentTypeDTO}> = (props) => {
          const {code,data} = props ?? {};

          return  updateDocumentType(code,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateDocumentType>>>
    export type UpdateDocumentTypeMutationBody = UpdateDocumentTypeDTO
    export type UpdateDocumentTypeMutationError = unknown

    export const useUpdateDocumentType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDocumentType>>, TError,{code: string;data: UpdateDocumentTypeDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDocumentType>>,
        TError,
        {code: string;data: UpdateDocumentTypeDTO},
        TContext
      > => {

      const mutationOptions = getUpdateDocumentTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const deleteDocumentType = (
    code: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<null>(
      {url: `/api/document-types/${code}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteDocumentTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentType>>, TError,{code: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentType>>, TError,{code: string}, TContext> => {

const mutationKey = ['deleteDocumentType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocumentType>>, {code: string}> = (props) => {
          const {code} = props ?? {};

          return  deleteDocumentType(code,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocumentType>>>
    
    export type DeleteDocumentTypeMutationError = unknown

    export const useDeleteDocumentType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentType>>, TError,{code: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDocumentType>>,
        TError,
        {code: string},
        TContext
      > => {

      const mutationOptions = getDeleteDocumentTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAllDocumentTypes = (
    params: GetAllDocumentTypesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PageDocumentTypeDTO>(
      {url: `/api/document-types`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAllDocumentTypesQueryKey = (params?: GetAllDocumentTypesParams,) => {
    return [`/api/document-types`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAllDocumentTypesQueryOptions = <TData = Awaited<ReturnType<typeof getAllDocumentTypes>>, TError = unknown>(params: GetAllDocumentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllDocumentTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllDocumentTypes>>> = ({ signal }) => getAllDocumentTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllDocumentTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllDocumentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllDocumentTypes>>>
export type GetAllDocumentTypesQueryError = unknown


export function useGetAllDocumentTypes<TData = Awaited<ReturnType<typeof getAllDocumentTypes>>, TError = unknown>(
 params: GetAllDocumentTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocumentTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllDocumentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllDocumentTypes<TData = Awaited<ReturnType<typeof getAllDocumentTypes>>, TError = unknown>(
 params: GetAllDocumentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocumentTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllDocumentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllDocumentTypes<TData = Awaited<ReturnType<typeof getAllDocumentTypes>>, TError = unknown>(
 params: GetAllDocumentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllDocumentTypes<TData = Awaited<ReturnType<typeof getAllDocumentTypes>>, TError = unknown>(
 params: GetAllDocumentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllDocumentTypesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createDocumentType = (
    createDocumentTypeDTO: CreateDocumentTypeDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DocumentTypeDTO>(
      {url: `/api/document-types`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDocumentTypeDTO, signal
    },
      options);
    }
  


export const getCreateDocumentTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentType>>, TError,{data: CreateDocumentTypeDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createDocumentType>>, TError,{data: CreateDocumentTypeDTO}, TContext> => {

const mutationKey = ['createDocumentType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDocumentType>>, {data: CreateDocumentTypeDTO}> = (props) => {
          const {data} = props ?? {};

          return  createDocumentType(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof createDocumentType>>>
    export type CreateDocumentTypeMutationBody = CreateDocumentTypeDTO
    export type CreateDocumentTypeMutationError = unknown

    export const useCreateDocumentType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentType>>, TError,{data: CreateDocumentTypeDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDocumentType>>,
        TError,
        {data: CreateDocumentTypeDTO},
        TContext
      > => {

      const mutationOptions = getCreateDocumentTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const validateFileForDocumentType = (
    code: string,
    params: ValidateFileForDocumentTypeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ValidateFileForDocumentType200>(
      {url: `/api/document-types/${code}/validate-file`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getValidateFileForDocumentTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateFileForDocumentType>>, TError,{code: string;params: ValidateFileForDocumentTypeParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof validateFileForDocumentType>>, TError,{code: string;params: ValidateFileForDocumentTypeParams}, TContext> => {

const mutationKey = ['validateFileForDocumentType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateFileForDocumentType>>, {code: string;params: ValidateFileForDocumentTypeParams}> = (props) => {
          const {code,params} = props ?? {};

          return  validateFileForDocumentType(code,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateFileForDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof validateFileForDocumentType>>>
    
    export type ValidateFileForDocumentTypeMutationError = unknown

    export const useValidateFileForDocumentType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateFileForDocumentType>>, TError,{code: string;params: ValidateFileForDocumentTypeParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateFileForDocumentType>>,
        TError,
        {code: string;params: ValidateFileForDocumentTypeParams},
        TContext
      > => {

      const mutationOptions = getValidateFileForDocumentTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const checkDocumentTypeExists = (
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CheckDocumentTypeExists200>(
      {url: `/api/document-types/${code}/exists`, method: 'GET', signal
    },
      options);
    }
  

export const getCheckDocumentTypeExistsQueryKey = (code?: string,) => {
    return [`/api/document-types/${code}/exists`] as const;
    }

    
export const getCheckDocumentTypeExistsQueryOptions = <TData = Awaited<ReturnType<typeof checkDocumentTypeExists>>, TError = unknown>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkDocumentTypeExists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckDocumentTypeExistsQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkDocumentTypeExists>>> = ({ signal }) => checkDocumentTypeExists(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkDocumentTypeExists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CheckDocumentTypeExistsQueryResult = NonNullable<Awaited<ReturnType<typeof checkDocumentTypeExists>>>
export type CheckDocumentTypeExistsQueryError = unknown


export function useCheckDocumentTypeExists<TData = Awaited<ReturnType<typeof checkDocumentTypeExists>>, TError = unknown>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkDocumentTypeExists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkDocumentTypeExists>>,
          TError,
          Awaited<ReturnType<typeof checkDocumentTypeExists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCheckDocumentTypeExists<TData = Awaited<ReturnType<typeof checkDocumentTypeExists>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkDocumentTypeExists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkDocumentTypeExists>>,
          TError,
          Awaited<ReturnType<typeof checkDocumentTypeExists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCheckDocumentTypeExists<TData = Awaited<ReturnType<typeof checkDocumentTypeExists>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkDocumentTypeExists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useCheckDocumentTypeExists<TData = Awaited<ReturnType<typeof checkDocumentTypeExists>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkDocumentTypeExists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCheckDocumentTypeExistsQueryOptions(code,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const searchDocumentTypes = (
    params: SearchDocumentTypesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DocumentTypeDTO[]>(
      {url: `/api/document-types/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getSearchDocumentTypesQueryKey = (params?: SearchDocumentTypesParams,) => {
    return [`/api/document-types/search`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchDocumentTypesQueryOptions = <TData = Awaited<ReturnType<typeof searchDocumentTypes>>, TError = unknown>(params: SearchDocumentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchDocumentTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchDocumentTypes>>> = ({ signal }) => searchDocumentTypes(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchDocumentTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchDocumentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof searchDocumentTypes>>>
export type SearchDocumentTypesQueryError = unknown


export function useSearchDocumentTypes<TData = Awaited<ReturnType<typeof searchDocumentTypes>>, TError = unknown>(
 params: SearchDocumentTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDocumentTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof searchDocumentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchDocumentTypes<TData = Awaited<ReturnType<typeof searchDocumentTypes>>, TError = unknown>(
 params: SearchDocumentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDocumentTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof searchDocumentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchDocumentTypes<TData = Awaited<ReturnType<typeof searchDocumentTypes>>, TError = unknown>(
 params: SearchDocumentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useSearchDocumentTypes<TData = Awaited<ReturnType<typeof searchDocumentTypes>>, TError = unknown>(
 params: SearchDocumentTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchDocumentTypesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getRequiredDocumentTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DocumentTypeDTO[]>(
      {url: `/api/document-types/required`, method: 'GET', signal
    },
      options);
    }
  

export const getGetRequiredDocumentTypesQueryKey = () => {
    return [`/api/document-types/required`] as const;
    }

    
export const getGetRequiredDocumentTypesQueryOptions = <TData = Awaited<ReturnType<typeof getRequiredDocumentTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRequiredDocumentTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequiredDocumentTypes>>> = ({ signal }) => getRequiredDocumentTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocumentTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRequiredDocumentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getRequiredDocumentTypes>>>
export type GetRequiredDocumentTypesQueryError = unknown


export function useGetRequiredDocumentTypes<TData = Awaited<ReturnType<typeof getRequiredDocumentTypes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocumentTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequiredDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof getRequiredDocumentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequiredDocumentTypes<TData = Awaited<ReturnType<typeof getRequiredDocumentTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocumentTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRequiredDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof getRequiredDocumentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRequiredDocumentTypes<TData = Awaited<ReturnType<typeof getRequiredDocumentTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetRequiredDocumentTypes<TData = Awaited<ReturnType<typeof getRequiredDocumentTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRequiredDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRequiredDocumentTypesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDocumentTypesList = (
    params?: GetDocumentTypesListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DocumentTypeDTO[]>(
      {url: `/api/document-types/list`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetDocumentTypesListQueryKey = (params?: GetDocumentTypesListParams,) => {
    return [`/api/document-types/list`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDocumentTypesListQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentTypesList>>, TError = unknown>(params?: GetDocumentTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentTypesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentTypesList>>> = ({ signal }) => getDocumentTypesList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentTypesListQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentTypesList>>>
export type GetDocumentTypesListQueryError = unknown


export function useGetDocumentTypesList<TData = Awaited<ReturnType<typeof getDocumentTypesList>>, TError = unknown>(
 params: undefined |  GetDocumentTypesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentTypesList>>,
          TError,
          Awaited<ReturnType<typeof getDocumentTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentTypesList<TData = Awaited<ReturnType<typeof getDocumentTypesList>>, TError = unknown>(
 params?: GetDocumentTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentTypesList>>,
          TError,
          Awaited<ReturnType<typeof getDocumentTypesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentTypesList<TData = Awaited<ReturnType<typeof getDocumentTypesList>>, TError = unknown>(
 params?: GetDocumentTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentTypesList<TData = Awaited<ReturnType<typeof getDocumentTypesList>>, TError = unknown>(
 params?: GetDocumentTypesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentTypesListQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDocumentTypesForFileType = (
    params: GetDocumentTypesForFileTypeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DocumentTypeDTO[]>(
      {url: `/api/document-types/for-file-type`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetDocumentTypesForFileTypeQueryKey = (params?: GetDocumentTypesForFileTypeParams,) => {
    return [`/api/document-types/for-file-type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDocumentTypesForFileTypeQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentTypesForFileType>>, TError = unknown>(params: GetDocumentTypesForFileTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypesForFileType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentTypesForFileTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentTypesForFileType>>> = ({ signal }) => getDocumentTypesForFileType(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypesForFileType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDocumentTypesForFileTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentTypesForFileType>>>
export type GetDocumentTypesForFileTypeQueryError = unknown


export function useGetDocumentTypesForFileType<TData = Awaited<ReturnType<typeof getDocumentTypesForFileType>>, TError = unknown>(
 params: GetDocumentTypesForFileTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypesForFileType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentTypesForFileType>>,
          TError,
          Awaited<ReturnType<typeof getDocumentTypesForFileType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentTypesForFileType<TData = Awaited<ReturnType<typeof getDocumentTypesForFileType>>, TError = unknown>(
 params: GetDocumentTypesForFileTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypesForFileType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentTypesForFileType>>,
          TError,
          Awaited<ReturnType<typeof getDocumentTypesForFileType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDocumentTypesForFileType<TData = Awaited<ReturnType<typeof getDocumentTypesForFileType>>, TError = unknown>(
 params: GetDocumentTypesForFileTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypesForFileType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDocumentTypesForFileType<TData = Awaited<ReturnType<typeof getDocumentTypesForFileType>>, TError = unknown>(
 params: GetDocumentTypesForFileTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypesForFileType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDocumentTypesForFileTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getActiveDocumentTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DocumentTypeDTO[]>(
      {url: `/api/document-types/active`, method: 'GET', signal
    },
      options);
    }
  

export const getGetActiveDocumentTypesQueryKey = () => {
    return [`/api/document-types/active`] as const;
    }

    
export const getGetActiveDocumentTypesQueryOptions = <TData = Awaited<ReturnType<typeof getActiveDocumentTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveDocumentTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveDocumentTypes>>> = ({ signal }) => getActiveDocumentTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveDocumentTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActiveDocumentTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveDocumentTypes>>>
export type GetActiveDocumentTypesQueryError = unknown


export function useGetActiveDocumentTypes<TData = Awaited<ReturnType<typeof getActiveDocumentTypes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveDocumentTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof getActiveDocumentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveDocumentTypes<TData = Awaited<ReturnType<typeof getActiveDocumentTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveDocumentTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveDocumentTypes>>,
          TError,
          Awaited<ReturnType<typeof getActiveDocumentTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveDocumentTypes<TData = Awaited<ReturnType<typeof getActiveDocumentTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActiveDocumentTypes<TData = Awaited<ReturnType<typeof getActiveDocumentTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveDocumentTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActiveDocumentTypesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



